const brandActionTypes = {
  GET_BRAND_DATA: "get_brand_data",
  SAVE_BRAND_DATA: "save_brand_data",
  SET_ERROR_DATA: "set_error_data"
};

export default brandActionTypes;
